define('SageDotCom/Components/Content/Collections/MenuTabSet',["jquery", "eventManager", "SageDotCom/Utility/sanitizer"], function ($, eventManager, sanitizer) {
    function MenuTabSet(scope) {
        const $container = $(scope).find(".menu-tabSet-container").first();
        const $buttonsContainer = $container.find(".tab-panels-button-container");
        const $panelsContainer = $container.find(".tab-panels-content-container");
        const $megaMenuItemParent = $container.parents("li.score-megamenu-dropdown");
        const $nextMegaMenu = $megaMenuItemParent.next();

        var desktopButtons = $buttonsContainer.find(".menu-tabSet-panel-button");
        var mobileButtons = $megaMenuItemParent.parent().find(".menu-tabSet-button");
        var panels = $panelsContainer.find(".menu-tabSet-panel-content");

        $megaMenuItemParent.addClass("menu-tabset-inside");

        // need to move the panel buttons and content into their respective containers
        var panelsToMove = $container.find(".menu-tabSet-panel");
        panelsToMove.each((_, panel) => {
            var $panel = $(panel);
            var $panelButton = $panel.find(".menu-tabSet-panel-button");
            var $panelContent = $panel.find(".menu-tabSet-panel-content");

            if ($panelButton.length && $panelContent.length) {
                $buttonsContainer.append($panelButton);
                $panelsContainer.append($panelContent);
            }
            // create a duplicate of the buttons for mobile view
            var megaMenuitem = $('<li class="score-megamenu-dropdown" data-related-menutabset-id="' + sanitizer.stripHtml($(scope).attr("data-attr-id")) + '"><a class="menu-tabSet-button" href="#" data-toggle="dropdown" tabindex="0" aria-expanded="false">' + sanitizer.stripHtml($panelButton.text()) + '</a></li>');
            $nextMegaMenu.before(megaMenuitem);

            // we can now delete the panel parent as it is no longer needed
            $panel.remove();
        });

        // now content and buttons are moved to correct placeholder find final scopes of panels and buttons 
        desktopButtons = $buttonsContainer.find(".menu-tabSet-panel-button");
        mobileButtons = $megaMenuItemParent.parent().find(".menu-tabSet-button");
        panels = $panelsContainer.find(".menu-tabSet-panel-content");

        mobileButtons.parent().hide();

        desktopButtons.each(function () {
            // add functionality for changing tabs
            var button = $(this);
            button.on("click", (event) => {
                event.stopPropagation();
                var buttonIndex = desktopButtons.index(button);

                // find the panel with the same index and set to active
                // set everything else to not active
                for (var i = 0; i < desktopButtons.length; i++) {
                    if (i === buttonIndex) {
                        // show panel as it relates to the button clicked
                        $(panels[i]).addClass("active");
                        $(desktopButtons[i]).addClass("active");
                    }
                    else {
                        $(panels[i]).removeClass("active");
                        $(desktopButtons[i]).removeClass("active");
                    }
                }
            });

            button.on("mouseenter", (event) => {
                button.click();
            });

            button.on("keyup", function (event) {
                if (event.keyCode === 13) {
                    // stop desktop panel from closing when changing tabs using keyboard
                    event.stopPropagation();
                }
            }); 
        });

        mobileButtons.each(function () {
            // add functionality for opening panel
            var button = $(this);
            button.on("click", (event) => {
                event.stopPropagation();
                $megaMenuItemParent.addClass("open");
                button.attr('aria-expanded', 'true');
                var buttonIndex = mobileButtons.index(button);
                $(desktopButtons[buttonIndex]).click();
            });

            button.on("keyup", function (event) {
                event.stopPropagation();
                if (event.keyCode === 13) {
                    // make sure focus is inside panel so it can be tabbed through (unlikely though as on mobile)
                    $megaMenuItemParent.find(".back-button").focus();
                }
            });
        });

        //automatically have the first tab selected when in desktop view
        if (!$(".score-hamburger.navbar-toggle").is(":visible")) {
            $(desktopButtons[0]).click();
        }
        else {
            panels.each(function () {
                var currentPanel = $(this);
                currentPanel.removeClass("active");
            });   
        }

        eventManager.subscribe("control-menu-tabset-button-visibility", function () {
            if ($(".score-hamburger.navbar-toggle").is(":visible")) {
                // showing mobile buttons are controlld in main.js
                desktopButtons.hide();
            }
            else {
                desktopButtons.show();
                $(desktopButtons[0]).click();
                mobileButtons.parent().hide();
            }
        });
        
    }

    MenuTabSet.init = function init(args) {
        return args.IsEditorEditing ? null : new MenuTabSet(args.scope);
    };

    return MenuTabSet;
});
